import styled from "styled-components";

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 14px 12px;
  background-color: #22272b;
  box-sizing: border-box;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const HorizonChip = styled.span<{
  $background: string;
  $color: string;
  $border: string;
}>`
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 16px;
  background: ${(p) => p.$background};
  color: ${(p) => p.$color};
  border: ${(p) => p.$border};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
`;

export const ConfidenceBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  flex: 1;
  max-width: 220px;
`;

export const ConfidenceLabel = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
`;

export const ConfidenceTrack = styled.div`
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.12);
  overflow: hidden;
`;

export const ConfidenceFill = styled.div<{
  $width: number;
  $color: string;
}>`
  height: 100%;
  width: ${(p) => p.$width}%;
  background: ${(p) => p.$color};
  border-radius: 2px;
  transition: width 0.2s ease;
`;

export const Outlook = styled.p`
  margin: 0;
  color: #ffffff;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  white-space: pre-wrap;
`;

export const BlockLabel = styled.div`
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 6px;
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DriversList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const DriverItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  line-height: 16px;
`;

export const DriverBullet = styled.span`
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  margin-top: 5px;
  border-radius: 50%;
  background: #56b3ff;
`;

export const QuantGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const QuantCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const QuantMetric = styled.div`
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  line-height: 14px;
`;

export const QuantValueRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
`;

export const QuantValue = styled.span`
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  line-height: 22px;
`;

export const QuantUnit = styled.span`
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
  line-height: 16px;
`;

export const MetaChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const MetaChip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 12px;
  background: rgba(250, 250, 250, 0.12);
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
  line-height: 14px;
`;

export const QuantNote = styled.div`
  color: rgba(255, 255, 255, 0.55);
  font-size: 11px;
  line-height: 14px;
`;

export const RussiaText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 12px;
  line-height: 17px;
`;

export const EvidenceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const EvidenceItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const EvidenceLink = styled.a`
  color: #71c6fa;
  font-size: 12px;
  line-height: 16px;
  text-decoration: none;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }
`;

export const EvidenceText = styled.span`
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  line-height: 16px;
  word-break: break-word;
`;

export const EvidencePages = styled.span`
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  line-height: 14px;
`;
